export default __webpack_public_path__ + "static/media/smedx.804e6466.jpg";